module.exports = __webpack_public_path__ + "img/project12_6.jpg.ddc2fb7d.webp";